import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ProgressBar from "components/DesignSystem/ProgressBar/ProgressBar";
import { FilingsSparkle } from "components/icons/FilingsSparkle";
import { InkleAiAvatar } from "components/icons/InkleAiAvatar";
import { pluralize } from "utils/pluralize";

const USER_NAME = "John";
const FILINGS_COUNT = 4;
const PROGRESS_DURATION_MS = 5000;
const FILINGS_DASHBOARD_ROUTE = "/v2/filings-dashboard";

export const FilingsDetected = () => {
  const history = useHistory();

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setProgress(100));

    return () => cancelAnimationFrame(raf);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      history.replace(FILINGS_DASHBOARD_ROUTE);
    }, PROGRESS_DURATION_MS);

    return () => clearTimeout(timer);
  }, [history]);

  return (
    <div className="t-flex t-min-h-screen t-items-center t-justify-center t-bg-surface t-px-5">
      <div className="t-flex t-w-full t-max-w-md t-flex-col t-items-center t-gap-[54px]">
        <div className="t-flex t-flex-col t-items-center t-gap-10">
          <div className="t-flex t-flex-col t-items-center t-gap-3">
            <InkleAiAvatar />

            <p className="t-text-title-h2-bold t-text-text-60">
              Hello, {USER_NAME}!
            </p>
          </div>

          <div className="t-flex t-flex-col t-items-center t-gap-2">
            <p className="t-text-[40px] t-font-bold t-leading-none t-text-text-60">
              {FILINGS_COUNT}
            </p>

            <div className="t-flex t-items-center t-gap-1.5">
              <FilingsSparkle />

              <p className="t-text-subtitle-lg t-text-text-60">
                {pluralize(FILINGS_COUNT, "filing", "filings", false)} detected
                for you
              </p>
            </div>

            <p className="t-text-body-lg t-text-text-30">
              Found from the company information you gave us
            </p>
          </div>
        </div>

        <ProgressBar.Root value={progress} className="t-w-full">
          <ProgressBar.Indicator
            progress={progress}
            className="t-bg-inkle-gradient"
            style={{
              transform: `translateX(-${100 - progress}%)`,
              transitionDuration: `${PROGRESS_DURATION_MS}ms`,
            }}
          />
        </ProgressBar.Root>
      </div>
    </div>
  );
};
